import React from 'react';
import { gallery } from '../data/masterclass';
export function GalleryCarousel() {
  const loop = [...gallery, ...gallery];
  return <div className="mt-14" data-id="element-59" data-mp="29vidoy1a91zf">
      <p className="text-[11px] font-bold uppercase tracking-overline text-gold" data-id="element-60" data-mp="29xcq1nyhnlrw">
        Real life, in real seasons
      </p>

      <div className="marquee mt-6 overflow-hidden" role="region" aria-label="Photos of Curtis and Spring Eatmon IV" data-id="element-61" data-mp="205qj43t6o8uy">
        <ul className="marquee-track flex w-max gap-4" data-id="element-62" data-mp="1w4wvlbjnkw2l">
          {loop.map((src, i) => <li key={`${src}-${i}`} className="w-56 shrink-0 sm:w-64 lg:w-72" data-id="element-63" data-mp="1r2xs81nwxz5n" data-mpi={i}>
              <img src={src} alt={i < gallery.length ? `Curtis and Spring Eatmon IV, photo ${i + 1}` : ''} aria-hidden={i >= gallery.length} loading="lazy" className="h-72 w-full rounded-xl object-cover object-top sm:h-80 lg:h-96" data-id="element-64" data-mp="1m679t7omyrh2" />
            </li>)}
        </ul>
      </div>
    </div>;
}